import * as React from 'react'
import { IGoinZoneObject, GoinZoneType } from '../../types'
import { EyeClose, EyeOpen } from '../icons/main-menu'

interface IoinZonesListItemProps {
  zone: IGoinZoneObject
  setZoneVisible: (zone: IGoinZoneObject, visible: boolean) => void
}

class ZonesListItem extends React.Component<IoinZonesListItemProps, any> {
  public render() {
    const { zone } = this.props
    return (
      <div style={{ height: '35px', lineHeight: '35px' }} className='flex px1'>
        <div
          style={{
            cursor: 'pointer',
            width: '100px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }}
        >
          {zone.name}
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <div className='flex' style={{ width: '100%', height: '100%' }}>
            <div className='flex' style={{ margin: 'auto' }}>
              {zone.visible && (
                <div style={{ cursor: 'pointer' }} onClick={this.onSetInvisible}>
                  <EyeOpen style={{ margin: 'auto' }} className='mr1 block' />
                </div>
              )}
              {!zone.visible && (
                <div style={{ cursor: 'pointer' }} onClick={this.onSetVisible}>
                  <EyeClose style={{ margin: 'auto' }} className='mr1 block' />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  private onSetInvisible = () => {
    this.props.setZoneVisible(this.props.zone, false)
  }

  private onSetVisible = () => {
    this.props.setZoneVisible(this.props.zone, true)
  }
}

export default ZonesListItem



// WEBPACK FOOTER //
// ./src/components/navigation/ZonesListItem.tsx